import type { UnitOfWork } from "../../../__generated__/types.gqlgenerated";
import type { ViewjobQuery } from "../__generated__/viewjob.gqlgenerated";
import type { SalaryInfoModel } from "../components/core/ProfileInsights/components/PreferencesCollection/types";

/**
 * Converts unitOfWork values to their corresponding salary type format
 */
const convertUnitOfWork = (unitOfWork: UnitOfWork | undefined): string | undefined => {
  if (!unitOfWork) {
    return undefined;
  }

  const conversionMap: Record<string, string> = {
    HOUR: "HOURLY",
    DAY: "DAILY",
    WEEK: "WEEKLY",
    BIWEEK: "BIWEEKLY",
    MONTH: "MONTHLY",
    QUARTER: "QUARTERLY",
    YEAR: "YEARLY",
  };

  return conversionMap[unitOfWork] || unitOfWork;
};

export const buildCompensationModel = (
  viewjob: NonNullable<ViewjobQuery["viewjob"]>,
): SalaryInfoModel | undefined => {
  const compensation = viewjob.job?.compensation;
  const jobseekerPreferences = viewjob.job?.jobseekerPreferences;
  const minimumPayPreference = jobseekerPreferences?.minimumPayPreferences[0];

  if (!compensation?.baseSalary) {
    return undefined;
  }

  return {
    salaryText: compensation?.formattedText ?? "",
    salaryMax: viewjob.details?.salaryInfo?.max,
    salaryMin: viewjob.details?.salaryInfo?.min,
    salaryType: convertUnitOfWork(compensation?.baseSalary?.unitOfWork ?? undefined),
    matchingSalary: jobseekerPreferences?.paySentiment === "POSITIVE",
    minimumPayPreferencePresent: (minimumPayPreference?.payAmount ?? 0) > 0,
    userMinimumPayAmount: minimumPayPreference?.payAmount ?? undefined,
    userMinimumPaySalaryType: minimumPayPreference?.salaryType ?? undefined,
  };
};
